import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "skeletonClassName", "isDark"];
import cn from "classnames";
import { Skeleton } from "@crehana/ui";
import { AcademyCardContainerSkeleton } from "./AcademyCard.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var AcademyCardSkeleton = function AcademyCardSkeleton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'w-full' : _ref$className,
    skeletonClassName = _ref.skeletonClassName,
    isDark = _ref.isDark,
    academyCardSkeletonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("article", _objectSpread(_objectSpread({
    className: cn('flex flex-col', className)
  }, academyCardSkeletonProps), {}, {
    children: /*#__PURE__*/_jsx(AcademyCardContainerSkeleton, {
      className: "relative  overflow-hidden",
      children: /*#__PURE__*/_jsx(Skeleton, {
        className: cn('w-full h-full', skeletonClassName),
        isDark: isDark
      })
    })
  }));
};
export default AcademyCardSkeleton;